
import React, { useRef, useEffect, useCallback, useState, Suspense } from "react";
// @ts-ignore
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next"
import { makeStyles } from "@material-ui/core/styles"
//@ts-ignore
// Internal
const CONSTS = require("shared/consts")
import useIsLoggedIn from "../utils/use-is-logged-in"
// @ts-ignore
import { requestJSON } from "../utils/request-module"
import "../utils/translate"
import useIsWide from "../utils/use-is-wide"
import cloneDeep from 'lodash/cloneDeep'
import _ from "lodash"
// Internal
import InputComponent from "../components/input-component/input-component"
import CompilationErrorsBox from "../components/compilation-errors"
import Button from "../components/button"
import useFeature from "../utils/subscriptionWrapper"
import isSelectedContractExists from "../components/input-component/is-selected-contact-exists"
import useEditorHeight from "../components/input-component/use-editor-height"
import { trackAndCall } from "src/utils/tracking"
import SimplifierToolHeader from "src/components/simplifier-tool-header"
import { synchronizeIcon, successIcon, closeIcon } from "../components/icons-svg";
import { getLibraryURL } from "../utils/get-simulation-library-url";
import { navigate } from "src/utils/react-utils";
import consts from "shared/consts";
import { Checkbox } from "@material-ui/core";
import store from "src/store";
import { Input } from "src/components/input";
import useHistory from "../use-history";

const PAGES = {
  interactive: "interactive",
  noninteractive: "noninteractive",
}

export default function Simplifier({ setIsSubmitLoading, isLoading, scanningCancelled }) {

  const { t } = useTranslation();
  const { id } = useParams();
  const history = useHistory();

  // State and Hooks (state managed by hooks)
  var [mainFile, setMainFile] = useState("mainfile.sol")
  var [mainContract, setMainContract] = useState("")
  var [showEditor, setShowEditor] = useState(true);
  const [highlightRange, setHighlightRange] = useState(null)
  const [saveMessage, setSaveMessage] = useState(null)

  const isWideScreen = useIsWide()

  const title = 'Editing review files';
  const description = (isWideScreen) ? t("token_and_smart_contract_simplifier_intro_start_multifile") : t("token_and_smart_contract_simplifier_intro_start");

  const { isLoggedIn, userInfo } = useIsLoggedIn()

  const [compilerVersion, setCompilerVersion] = useState("v0.8.15+commit.e14f2714")

  const [files, setFiles] = useState()
  const [simplifiedData, setSimplifiedData] = useState()

  const [importPopoverAnchorEl, setImportPopoverAnchorEl] = useState(null)

  const defaultResponse = { test_results: [], errors: [] }
  const [nonInteractiveResponse, setNonInteractiveResponse] = useState(
    defaultResponse,
  )
  const [viaIR, set_viaIR] = useState(false);
  const [optimization, setOptimization] = useState(false);
  const [bytecode, set_bytecode] = useState('');
  const [optimizeRuns, setOptimizeRuns] = useState(0);
  const [reviewData, setReviewData] = useState(null);

  useEffect(() => {
    getSimplifierDataAndReviewDetails();
  }, []);

  const getSimplifierDataAndReviewDetails = async () => {
    try {
      let promiseOne = await requestJSON("GET", '/review/simplifier-data/' + id);
      let promiseTwo= await requestJSON("GET", '/review/my-review/' + id);

      let response = await Promise.all([promiseOne, promiseTwo]);

      let simplifiedData = response[0];
      if (simplifiedData.files) {
        simplifiedData.files.forEach(file => {
          file.path = file.path || file.name
          delete file.name
        })
      }
      if (Object.entries(simplifiedData).length > 0) {
      }
      setSimplifiedData(simplifiedData)
      setMainContract(simplifiedData.mainContractName)
      setMainFile(simplifiedData.mainFileName)
      setCompilerVersion(simplifiedData.compilerVersion)
      setFiles(simplifiedData?.files || [{ path: "main.sol", content: "" }])
      setOptimization(simplifiedData?.compilerSettings?.optimizer?.enabled);
      set_viaIR(simplifiedData?.compilerSettings?.viaIR);
      set_bytecode(simplifiedData?.bytecode);
      setOptimizeRuns(simplifiedData?.compilerSettings?.optimizer?.runs || 0);
      setReviewData(response[1]);
    } catch (err) {
      console.log('Some error has occured while fetching completed simplifier data and review data ', err);
    }
  }

  useEffect(() => {
    if (!files) return
    setSaveMessage('saving');
    let url = '/review/save-simplifier-data/';
    setFiles(currentFiles => {
      let body = {
        reviewId: id,
        files: files,
        mainContractName: mainContract,
        mainFileName: mainFile,
        compilerVersion,
        compilerSettings:{
          optimizer:{
            enabled:Boolean(optimization),
            runs: optimizeRuns
          },
          viaIR,
        },
      }
      requestJSON("POST", url, body).then(response => {
        if (response === '' || response === undefined) {
          setSaveMessage('notSaved');
        } else {
          setSaveMessage('saved');
        }
        // saveSimplifierData(response);
      }).catch(err => {
        setSaveMessage('notSaved');
      })
      return currentFiles
    })
  }, [files, mainContract, mainFile, compilerVersion]);



  /** @type {import("../../../backend/interfaces").Test}*/
  var emptyTest
  var [selectedTest, __setSelectedTest] = useState(emptyTest)
  var [page, setPage] = useState(PAGES.noninteractive)

  const onLeavePage = (e = window.event) => {
    //@ts-ignore
    e.returnValue = t("are_you_sure_changes_not_saved") // browser support for: Gecko + IE
    return t("are_you_sure_changes_not_saved") // browser support for: Safari, Chrome, and other WebKit-derived browsers
  }

  const leavePageHandler = useCallback(onLeavePage, [])

  const addLeavePageHandlers = () => {
    window.addEventListener("beforeunload", leavePageHandler)
    window.addEventListener("blur", () => {
      window.removeEventListener("beforeunload", leavePageHandler)
    })
  }

  const removeLeavePageHandlers = () => {
    window.removeEventListener("beforeunload", leavePageHandler)
  }


  // Variables
  const useStyles = makeStyles(theme => ({
    terms: {
      padding: "2vw",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    app: {
      //@ts-ignore lightest not exists.
      backgroundColor: theme.palette.primary.lightest,
      minHeight: "100vh",
    },
  }))
  const classes = useStyles({})


  async function submitCode() {
    setPage(PAGES.noninteractive)
    try {
      setIsSubmitLoading(true)
      setNonInteractiveResponse(defaultResponse)
      if (!mainFile) {
        mainFile = "main.sol"
        setMainFile("main.sol")
      }

      try {
        let {abi,bytecode} = await store.getAbi({
          // @ts-ignore
          files: files,
          mainContract: mainContract,
          mainFile: mainFile,
          compilerVersion: compilerVersion,
          compilerSettings:{
            optimizer:{
              enabled:Boolean(optimization),
              runs: optimizeRuns
            },
            viaIR,
          },
        });

        let request = {
          //@ts-ignore
          files: files.map(item => ({
            name: item.path,
            content: item.content
          })),
          compilerSettings:{
            optimizer:{
               enabled:Boolean(optimization),
               runs: optimizeRuns
            },
            viaIR,
          },
          mainContractName: mainContract,
          mainFileName: mainFile,
          solVersion: compilerVersion
        }

        const response = await requestJSON("POST", "/static-simplify", request)
        if (scanningCancelled.current) {
          // In case scanning was cancelled
          scanningCancelled.current = false
          return
        }
        setIsSubmitLoading(false)
        if (response) {
          response.abi = abi;
          response.bytecode = bytecode;
          set_bytecode(bytecode)
          setNonInteractiveResponse(response);
          await saveSimplifierData(response);
          setShowEditor(false);
        }
      } catch (err) {
        setIsSubmitLoading(false)
      }
    } catch (err) {
    }
    setHighlightRange(null);
    addLeavePageHandlers()
  }

  const pageClickHandler = (e) => {
    if (!importPopoverAnchorEl) {
      return
    }
    const isClickOnToggleButtons = Boolean(e?.target?.closest("[id*='inputSelectionButton'"))
    if (!isClickOnToggleButtons) {
      setImportPopoverAnchorEl(null)
    }
  }


  const saveSimplifierData = async (response) => {
    let url = '/review/save-simplifier-data/';
    let body = {
      reviewId: id,
      originalAST: response.originalAST,
      simplifyAST: response.simplifyAST,
      bytecode:response.bytecode,
      files: response.files,
      simplifierContent: response.simplifierContent,
      warnings: response.warnings,
      english: response.english,
      errors: response.errors,
      compilerSettings:{
        optimizer:{
          enabled:Boolean(optimization),
          runs: optimizeRuns
        },
        viaIR,
      },
      abi: response.abi
    }
    try {
      let saveResponse = await requestJSON("POST", url, body);
      if (saveResponse.success && _.isEmpty(response?.errors)) {
          history.push("/solidity-wizard/" + id);
      }
    } catch (err) {
      console.log('Some error has occured while fetching my reviews ', err);
    }
  }

  var samples = consts.SAMPLES

  const loadSampleData = (sample) => {
    // We used clone to fix click sample1, then change text and click again sample1 = the modification should not be changed"
    // Should not be mutable
    setFiles(cloneDeep(sample.files))
    setMainContract('SampleContract')
    setCompilerVersion('v0.8.0+commit.c7dfd78e')
    setMainFile('main.sol')

  }


  // States:
  const [editorObject, setEditorObject] = useState(null)
  //@ts-ignore
  const [selectedFilePath, setSelectedFilePath] = useState(files?.[0]?.path)
  const [sourceLineNumber, setSourceLineNumber] = useState(null)


  // Effects
  const editorHeight = useEditorHeight()

  const isShowAllTests = useFeature(CONSTS.SUBSCRIPTIONS.ALL_SCR_TESTS)
  const isShowCategories = useFeature(CONSTS.SUBSCRIPTIONS.SHOW_SCR_CATEGORIES)
  // Constants:
  const editorLineHeight = 18

  // Variables:
  const sectionRef = useRef(null)
  const pageIntro = useRef(null)

  // Functions:

  const selectSourceCodeLine = (lineNumber = 0) => {
    let sourceScrollTop = 1
    if (lineNumber) {
      const scrollInPixels = lineNumber * editorLineHeight // scroll down to line to focus on
      const halfEditorHeight = editorHeight / 2 // scroll half way through editor, so that line in focus is half way down
      sourceScrollTop = scrollInPixels - halfEditorHeight // scroll down so that line in focus is half way down editor
    }
    if (editorObject) {
      editorObject.setScrollTop(sourceScrollTop)
      editorObject.setPosition({ column: 0, lineNumber })
    }
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }

  useEffect(() => {
    if (typeof sourceLineNumber === "number") {
      // first focus on specified line in monaco editor
      selectSourceCodeLine(sourceLineNumber)
      // then reset the line number, ready for the scrolling functionality to be called again
      setSourceLineNumber(null)
    }
  }, [sourceLineNumber])

  const scrollToSource = (lineNumber = 0, filePath) => {

    setHighlightRange({
      startLine: lineNumber,
      startColumn: 0,
      endLine: lineNumber,
      endColumn: 500
    })
    if (typeof filePath === "string") {
      setSelectedFilePath(filePath)
    }
    setSourceLineNumber(lineNumber)
    setShowEditor(true);
  }


  var sampleCss = `
  padding-left:5px;
  color:#799fd4;
  cursor: pointer;
  text-decoration-line: underline;
  `;


  let lowerVersionFound = false;
  let lowerVersionError = ''

  if (compilerVersion) {
    let versionArr = compilerVersion.split('+');
    let startingVersion = parseFloat(versionArr[0].replace('v', ''));
    if (startingVersion < 0.6) {
      lowerVersionFound = true;
      lowerVersionError = "*Selected version is not supported</br>&nbsp;&nbsp;Please choose 0.6.0 or above"
    }
  }

  const doNavigation = () => {
    if (showEditor) {
      navigate('/my-reviews');
    } else {
      setShowEditor(true);
    }
  }
  function gotoLibrary() {
    if (simplifiedData) {
      history.push(
        getLibraryURL({
          // @ts-ignore
          engagement_id: simplifiedData?.engagement._id,
          review_id: reviewData.reviewId
        })
      )
    }
  }
  if (!files) return <div>Loading...</div>
  return (
    <div className={classes.app} onClick={pageClickHandler}>
      <>
        <div ref={sectionRef}
          css={
            `
      padding: 35px;
      background: #F6F6FA;
      min-height: 100vh;
      `
          }
        >
          <Suspense fallback={null}>
            <div onMouseEnter={removeLeavePageHandlers}>
              <div css={`display:flex;`}>
                <div css={`flex-grow:1;`}>

                  <div css={`
                  font-size:24px;
                  color:#2E2E38;
              `}>
                    {title}
                  </div>
                </div>
                <div>
                  <span
                    css={`
                color:blue;
                cursor:pointer;
                :hover {
                  text-decoration:underline;
                }
                `}
                    onClick={gotoLibrary}>
                    Go to simulations
                  </span>
                </div>
              </div>
              <hr css={`
          margin-top:15px;
          border: 1px solid #EAEAF2;
          `}
              />
              {id && showEditor && (
                <div css={`
          display: flex;
          flex-direction: row;
          justify-content: space-between;
      `}>
                  <div>
                    <span>Sample Projects: </span>
                    {samples.map(sample =>
                      <span css={sampleCss}
                        onClick={() => { loadSampleData(sample) }}>{sample.name}&nbsp;</span>
                    )}
                  </div>
                  <div>
                    {saveMessage === 'saving' && (
                      <span
                      > {synchronizeIcon} Saving...</span>
                    )}
                    {saveMessage === 'saved' && (
                      <span
                      > {successIcon} Saved!</span>
                    )}
                    {saveMessage === 'notSaved' && (
                      <span
                      > {closeIcon} Error on saving data</span>
                    )}
                  </div>
                </div>
              )}
              {showEditor && (
                <div
                  css={`
          margin-top:25px;
          margin-bottom:100px;
        `}
                >
                  <InputComponent
                    CTA={
                      (inputMethod) =>
                        <>
                          <>
                            <Button
                              onClick={trackAndCall(CONSTS.MIXPANEL_EVENTS.SCAN_CONTRACT, submitCode, { inputMethodType: inputMethod })}
                              disabled={
                                isLoading ||
                                !compilerVersion ||
                                lowerVersionFound ||
                                !isSelectedContractExists({
                                  files,
                                  mainFile,
                                  mainContract,
                                })
                              }
                              color="secondary"
                              wrapped
                            >
                              {t("buttons.save")}
                            </Button>
                          </>
                          <>
                            <Checkbox
                              title="Via IR"
                              aria-label="via-ir"
                              id="via-ir"
                              checked={viaIR}
                              onChange={e => {
                                set_viaIR(e.target.checked);
                              }}
                            />                           
                            <label
                              htmlFor="via-ir"
                              css={`
                                  margin-top: 14px;
                                  margin-right: 10px;
                                  cursor: pointer;
                              `}>via IR</label>
                            &nbsp;
                            <Checkbox
                              title="Optimization"
                              aria-label="Optimization"
                              id="wizard_optimization"
                              checked={optimization}
                              onChange={e => {
                                if(e.target.checked){
                                  setOptimizeRuns(200);
                                } else {
                                  setOptimizeRuns(0);
                                }
                                setOptimization(e.target.checked);
                              }}
                            />                           
                            <label
                              htmlFor="xx"
                              css={`
                                  margin-top: 14px;
                                  margin-right: 10px;
                                  cursor: pointer;
                              `}>Optimization</label>
                            {optimization &&
                              <div><Input
                                label="Runs"
                                width="100"
                                labelBackground="#f6f6fa"
                                style={{
                                  height: 40
                                }}
                                value={optimizeRuns}
                                onChange={e => {
                                  if(/^\d*$/.test(e.target.value)) {
                                    setOptimizeRuns(e.target.value);
                                  }
                                }} />
                              </div>}
                          </>
                        </>

                    }
                    files={files}
                    //@ts-ignore
                    setFiles={setFiles}
                    isLoading={isLoading}
                    compilerVersion={compilerVersion}
                    setCompilerVersion={setCompilerVersion}
                    requestScrollEditorToTop={scrollToSource}
                    setEditorObject={setEditorObject}
                    editorHeight={editorHeight}
                    mainContract={mainContract}
                    setMainFile={setMainFile}
                    mainFile={mainFile}
                    setMainContract={setMainContract}
                    selectedFilePath={selectedFilePath}
                    setSelectedFilePath={setSelectedFilePath}
                    importPopoverAnchorEl={importPopoverAnchorEl}
                    setImportPopoverAnchorEl={setImportPopoverAnchorEl}
                    simplifier
                    highlightRange={highlightRange}
                    lowerVersionError={lowerVersionError}
                  />
                </div>
              )}
            </div>
            <div
              css={`
          margin-top:25px;
          margin-bottom:100px;
        `}
            >
              {((!_.isEmpty(nonInteractiveResponse.error) || !_.isEmpty(nonInteractiveResponse?.errors)) && !showEditor) && (
                // @ts-ignore
                <CompilationErrorsBox compilationErrors={nonInteractiveResponse.errors} scrollToSource={scrollToSource} />
              )}
            </div>
          </Suspense>
        </div>
      </>
    </div>
  )
}
